var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

export default createGetFormInitialValues;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/selectors/getFormInitialValues.js
// module id = 671
// module chunks = 1